import React, { Component } from 'react'

import LinesChart from 'modules/Charts/Lines/LinesChart'
import ContentChartTitle from 'modules/Content/ContentChart/ContentChartTitle'
import ContentChartFooter from 'modules/Content/ContentChart/ContentChartFooter'
import ContentDateModal from 'modules/Content/ContentChart/ContentDateModal'

import API from 'utils/api/api'
import APIURL from 'utils/api/urls'
import IndicatorTools from 'utils/indicators/indicatorTools'
import QueryTools from 'utils/queries/queryTools'

import Loading from 'components/Loading'
import Error from 'components/Error'

class LinesChartContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showLegend: true,
      showByGender: false,
      showTable: false,
      showModal: false,
      expanded: false,
      startingYear: 1900,
      endingYear: 2020,
      minYear: 0,
      maxYear: 0,
      chartRef: null,
      indicatorData: {},
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    let selectedRegionId = this.props.selectedRegionId
    let indicator = this.props.indicator

    let query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)

    API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query }))
      .then(response => IndicatorTools.getIndicatorEvolutionData(response.data))
      .then(indicatorEvolutionData => IndicatorTools.getMaxAndMinYearFromIndicator(indicatorEvolutionData))
      .then(({ min, max }) => {
        if (max - 10 >= min) min = max - 10
        this.setState({ minYear: min, maxYear: max, startingYear: min, endingYear: max, loading: false, error: false })
      })
      .catch(reason => {
        this.setState({ loading: false, error: true })
      })

    let indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0]
    this.setState({
      indicatorData
    })
  }

  functionSet() {
    const chartRef = this.state.chartRef
    let shouldShowLegend = this.state.showLegend
    const showLegend = () => {
      shouldShowLegend = !shouldShowLegend
      chartRef.current.chart.legend.update({
        enabled: shouldShowLegend
      })
      this.setState({ showLegend: shouldShowLegend })
    }

    let shouldShowByGender = this.state.showByGender
    const showByGender = () => {
      shouldShowByGender = !shouldShowByGender
      this.setState({ showByGender: shouldShowByGender })
    }
    const showTable = shouldShow => {
      this.setState({ showTable: shouldShow })
    }

    const modalFunctions = () => {
      const setDateRange = ({ startingYear, endingYear }) => {
        this.setState({
          startingYear,
          endingYear
        })
      }
      const openModal = () => {
        this.setState({
          showModal: true
        })
      }
      const closeModal = () => {
        this.setState({
          showModal: false
        })
      }

      return {
        setDateRange,
        openModal,
        closeModal
      }
    }

    const exportChart = fileType => {
      const chart = chartRef.current.getChart()
      let fileName = this.state.indicatorData.name
      let optionsToExport = {
        filename: fileName
      }

      if (fileType === 'CSV') {
        const csv = chart.getCSV(false)
        const hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = fileName + '.csv'
        hiddenElement.click()
      } else {
        switch (fileType) {
        case 'PNG':
          optionsToExport.type = 'image/png'
          break
        case 'JPEG':
          optionsToExport.type = 'image/jpeg'
          break
        case 'PDF':
          optionsToExport.type = 'application/pdf'
          break
        case 'SVG':
          optionsToExport.type = 'image/svg+xml'
          break
        default:
          optionsToExport.type = 'image/png'
          break
        }
        chart.exportChart(optionsToExport)
      }
    }
    const expandChart = () => {
      const shouldExpand = !this.state.expanded

      if (shouldExpand) {
        document.getElementsByTagName('html')[0].classList.add('ork-no-scroll')
      } else {
        document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll')
      }
      this.setState({ expanded: shouldExpand })
    }

    return {
      showLegend,
      showByGender,
      showTable,
      modalFunctions,
      exportChart,
      expandChart
    }
  }

	getRef = ref => {
	  this.setState({ chartRef: ref })
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  if (this.state.error) {
	    renderingComponent = <Error />
	  } else if (this.state.loading) {
	    renderingComponent = <Loading />
	  } else {
	    let { regionsData, referenceRegionsData, sameCountryRegionsData, allRegionsGroupRegionId } = this.props
	    let comparative
	    if (this.props.otherRegionsFilter !== undefined && this.props.otherRegionsFilter.length !== 0) {
	      comparative = this.props.otherRegionsFilter
	    } else {
	      comparative = {}
	    }
	    let generalRegionsData = {
	      regionsData,
	      referenceRegionsData,
        sameCountryRegionsData,
        comparative,
        allRegionsGroupRegionId
	    }
	    let linesToShow = {
	      allRegionsFilter: this.props.allRegionsFilter,
	      referenceRegionsFilter: this.props.referenceRegionsFilter,
	      sameCountryRegionsFilter: this.props.sameCountryRegionsFilter,
	      otherRegionsFilter: comparative
	    }
	    renderingComponent = (
	      <div className="col-lg-6">
	        <div className={`panel panel-default ${this.state.expanded ? 'panel-expanded' : ''}`}>
	          <ContentChartTitle indicator={this.props.indicator} layer={this.props.layer} chartType={'evolutionAbsolute'} />
	          <div className="panel-body">
	            <LinesChart
	              generalRegionsData={JSON.stringify(generalRegionsData)}
	              linesToShow={JSON.stringify(linesToShow)}
	              indicator={this.props.indicator}
	              startingYear={this.state.startingYear}
	              endingYear={this.state.endingYear}
	              selectedRegionId={this.props.selectedRegionId}
	              indicatorData={this.state.indicatorData}
	              expanded={this.state.expanded}
	              showLegend={this.state.showLegend}
	              showByGender={this.state.showByGender}
	              fn={this.getRef}
	            />
	          </div>
	          <ContentChartFooter
	            fn={this.functionSet()}
	            indicatorData={this.state.indicatorData}
	            expanded={this.state.expanded}
	            chartType={'evolutionAbsolute'}
	            showByGender={this.state.showByGender}
	          />
	        </div>
	        <ContentDateModal
	          show={this.state.showModal}
	          fn={this.functionSet().modalFunctions()}
	          startingYear={this.state.startingYear}
	          endingYear={this.state.endingYear}
	          minYear={this.state.minYear}
	          maxYear={this.state.maxYear}
	          multiple={true}
	        />
	      </div>
	    )
	  }
	  return renderingComponent
	}

	render() {
	  return <div>{this.renderIfAllOK()}</div>
	}
}

export default LinesChartContainer



// WEBPACK FOOTER //
// ./src/modules/Charts/Lines/LinesChartContainer/LinesChartContainer.jsx